<template>
    <div id="map" class="w-full h-full" />
</template>
  
<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
    name: 'MapboxMap',
    mounted() {
        mapboxgl.accessToken = 'pk.eyJ1Ijoid2Vzc2VsdmRyZXN0IiwiYSI6ImNseXk2Z3RoODFuZWEyaXMwZmsxOG53cmUifQ.CROE-eOWxWsXt8sRNt-imA'

        this.map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/wesselvdrest/clyy6ylyj00bs01ph73y07wb6',
            center: [4.899, 52.378],
            zoom: 12,
            projection: { name: "globe" }
        })

        const geojson = {
            type: 'FeatureCollection',
            features: this.$attrs.locations.map((f, i) => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [f.long, f.lat]
                },
                properties: {
                    title: f.name.en || `Locatie ${i + 1}`,
                    color: f.color || 'red' // e.g. 'red', 'blue', 'green'
                }
            }))
        }

        this.map.on('load', () => {
            this.map.addSource('points', {
                type: 'geojson',
                data: geojson
            })

            // Load one marker image for each color
            const colors = ['red', 'blue', 'green']

            Promise.all(colors.map(color => {
                return new Promise((resolve, reject) => {
                    this.map.loadImage(`https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png`, (error, image) => {
                        if (error) reject(error)
                        if (!this.map.hasImage(`marker-${color}`)) {
                            this.map.addImage(`marker-${color}`, image)
                        }
                        resolve()
                    })
                })
            })).then(() => {
                // Add symbol layer with dynamic image and text
                this.map.addLayer({
                    id: 'non-overlapping-markers',
                    type: 'symbol',
                    source: 'points',
                    layout: {
                        'icon-image': ['get', 'icon'], // dynamically chosen image
                        'icon-size': 0.5,
                        'icon-allow-overlap': false,
                        'text-field': ['get', 'title'],
                        'text-offset': [0, 1.5],
                        'text-size': 12
                    },
                    paint: {
                        'text-color': '#000000'
                    }
                })

                // After layer is added, set the icon-image dynamically based on color
                this.map.setLayoutProperty('non-overlapping-markers', 'icon-image', [
                    'concat',
                    'marker-',
                    ['get', 'color']
                ])
            })
        })
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove()
        }
    }
}
</script>